module.exports = __webpack_public_path__ + "img/consultService.6511b8b9.svg";